import * as yup from 'yup'

export const validateUpdateCourseChapters = yup.object().shape({
    name:yup
    .string()
    .min(2, 'El NOMBRE debe tener más de 2 caracteres'),
    path_video:yup
    .string()
    .min(2, 'El VIDEO debe tener más de 2 caracteres'),
    position:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    course_section_id:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    type: yup
    .string()
    .oneOf(['free', 'paid'], 'Debes elegir entre estas opciones'),
    duration: yup
    .string(),
})